<template>
    <MainContainer>
        <div class="changelog">
            <h2>Versionshinweise</h2>
            <hr />
            <Changelog />
        </div>
    </MainContainer>
</template>

<script>
import MainContainer from "@/components/MainContainer/MainContainer";
import Changelog from "@/components/Changelog/Changelog";

export default {
    name: "changelog",
    components: {
        MainContainer,
        Changelog
    },
    data() {
        return {};
    }
};
</script>
